(function () {
    'use strict';

    angular
        .module('glossaryTermEditModule', [
            'services.authenticatedUser',
            'aricModule',
            'governanceProcessModule',
            'services.attachments',
            'services.historyCtxt',
            'glossaryTermModule'
        ]);
})();
